import Component from '@bythepixel/component-loader';
import { DEFAULTS, STATES } from '@Front/components/accordion/_config';
import { handleComponentError } from '@Core/helpers/functions';

export default class Accordion extends Component {
  static selector = `[${DEFAULTS.accordion}]`;

  constructor(containerEl, options = { ...DEFAULTS, ...STATES }) {
    super(containerEl, options);

    this.mount();
  }

  mount() {
    const accordion = this.$container;
    const trigger = accordion.querySelector(`[${this.$options.trigger}]`);

    handleComponentError([
      [accordion?.tagName !== 'DETAILS', 'Accordion element uses an incorrect tag. It must be a DETAILS element.'],
      [!trigger, 'Accordion element has no trigger.'],
    ]);

    this.registerAnimationHandler(accordion);

    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      this.toggleAccordion(accordion);
    });
  }

  registerAnimationHandler(accordion) {
    accordion.addEventListener('animationend', (event) => {
      if (event.animationName !== this.$options.animation) {
        return;
      }

      switch (accordion.getAttribute(this.$options.state)) {
      case 'opening':
        accordion.setAttribute(this.$options.state, this.$options.opened);
        break;
      default:
        accordion.setAttribute(this.$options.state, this.$options.closed);
        accordion.toggleAttribute('open', false);
      }
    });
  }

  toggleAccordion(accordion) {
    accordion.setAttribute(this.$options.state, accordion.open ? this.$options.closing : this.$options.opening);

    if (!accordion.open) {
      accordion.toggleAttribute('open', true);
      this.closeOtherAccordions(accordion);
    }
  }

  closeOtherAccordions(openAccordion) {
    const accordions = document.querySelectorAll(this.constructor.selector);

    accordions.forEach((accordion) => {
      if (accordion !== openAccordion && accordion.open) {
        accordion.setAttribute(this.$options.state, this.$options.closing);
      }
    });
  }
}
